module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "form",
    staticClass: "form-group",
    class: {
      validate: _vm.canValidate, 'has-feedback': _vm.icon, 'has-error': _vm.canValidate && _vm.valid === false, 'has-success': _vm.canValidate && _vm.valid
    }
  }, [_vm._t("label", function() {
    return [(_vm.label) ? _c('label', {
      staticClass: "col-form-label",
      on: {
        "click": _vm.focus
      }
    }, [_vm._v(_vm._s(_vm.label))]) : _vm._e()]
  }), _vm._v(" "), (_vm.$slots.before || _vm.$slots.after) ? _c('div', {
    staticClass: "input-group"
  }, [_vm._t("before"), _vm._v(" "), (_vm.type === 'textarea') ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "cols": _vm.cols,
      "disabled": _vm.disabled,
      "list": _vm.id_datalist,
      "max": _vm.attr(_vm.max),
      "maxlength": _vm.maxlength,
      "min": _vm.attr(_vm.min),
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "required": _vm.required,
      "rows": _vm.rows,
      "step": _vm.step,
      "title": _vm.attr(_vm.title),
      "type": _vm.type == 'textarea' ? null : _vm.type
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "blur": _vm.emit,
      "focus": _vm.emit,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.val = $event.target.value
      }, _vm.emit],
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.type != 'textarea' && _vm.enterSubmit && _vm.submit()
      }
    }
  }) : ((_vm.type == 'textarea' ? null : _vm.type) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "cols": _vm.cols,
      "disabled": _vm.disabled,
      "list": _vm.id_datalist,
      "max": _vm.attr(_vm.max),
      "maxlength": _vm.maxlength,
      "min": _vm.attr(_vm.min),
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "required": _vm.required,
      "rows": _vm.rows,
      "step": _vm.step,
      "title": _vm.attr(_vm.title),
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.val) ? _vm._i(_vm.val, null) > -1 : (_vm.val)
    },
    on: {
      "blur": _vm.emit,
      "focus": _vm.emit,
      "input": _vm.emit,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.type != 'textarea' && _vm.enterSubmit && _vm.submit()
      },
      "change": function($event) {
        var $$a = _vm.val,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.val = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.val = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.val = $$c
        }
      }
    }
  }) : ((_vm.type == 'textarea' ? null : _vm.type) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "cols": _vm.cols,
      "disabled": _vm.disabled,
      "list": _vm.id_datalist,
      "max": _vm.attr(_vm.max),
      "maxlength": _vm.maxlength,
      "min": _vm.attr(_vm.min),
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "required": _vm.required,
      "rows": _vm.rows,
      "step": _vm.step,
      "title": _vm.attr(_vm.title),
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.val, null)
    },
    on: {
      "blur": _vm.emit,
      "focus": _vm.emit,
      "input": _vm.emit,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.type != 'textarea' && _vm.enterSubmit && _vm.submit()
      },
      "change": function($event) {
        _vm.val = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "cols": _vm.cols,
      "disabled": _vm.disabled,
      "list": _vm.id_datalist,
      "max": _vm.attr(_vm.max),
      "maxlength": _vm.maxlength,
      "min": _vm.attr(_vm.min),
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "required": _vm.required,
      "rows": _vm.rows,
      "step": _vm.step,
      "title": _vm.attr(_vm.title),
      "type": _vm.type == 'textarea' ? null : _vm.type
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "blur": _vm.emit,
      "focus": _vm.emit,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.val = $event.target.value
      }, _vm.emit],
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.type != 'textarea' && _vm.enterSubmit && _vm.submit()
      }
    }
  }), _vm._v(" "), (_vm.clearButton && _vm.value) ? _c('div', {
    class: {
      icon: _vm.icon
    }
  }, [_c('span', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.value = ''
      }
    }
  }, [_vm._v("×")])]) : _vm._e(), _vm._v(" "), (_vm.icon) ? _c('div', {
    staticClass: "icon"
  }, [(_vm.icon && _vm.valid !== null) ? _c('span', {
    class: ['form-control-feedback glyphicon', 'glyphicon-' + (_vm.valid ? 'ok' : 'remove')],
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._t("after")], 2) : [(_vm.type === 'textarea') ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "cols": _vm.cols,
      "disabled": _vm.disabled,
      "id": _vm.id,
      "list": _vm.id_datalist,
      "max": _vm.attr(_vm.max),
      "maxlength": _vm.maxlength,
      "min": _vm.attr(_vm.min),
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "required": _vm.required,
      "rows": _vm.rows,
      "step": _vm.step,
      "title": _vm.attr(_vm.title),
      "type": _vm.type == 'textarea' ? null : _vm.type
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "blur": _vm.emit,
      "focus": _vm.emit,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.val = $event.target.value
      }, _vm.emit],
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.type != 'textarea' && _vm.enterSubmit && _vm.submit()
      }
    }
  }) : ((_vm.type == 'textarea' ? null : _vm.type) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "cols": _vm.cols,
      "disabled": _vm.disabled,
      "id": _vm.id,
      "list": _vm.id_datalist,
      "max": _vm.attr(_vm.max),
      "maxlength": _vm.maxlength,
      "min": _vm.attr(_vm.min),
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "required": _vm.required,
      "rows": _vm.rows,
      "step": _vm.step,
      "title": _vm.attr(_vm.title),
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.val) ? _vm._i(_vm.val, null) > -1 : (_vm.val)
    },
    on: {
      "blur": _vm.emit,
      "focus": _vm.emit,
      "input": _vm.emit,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.type != 'textarea' && _vm.enterSubmit && _vm.submit()
      },
      "change": function($event) {
        var $$a = _vm.val,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.val = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.val = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.val = $$c
        }
      }
    }
  }) : ((_vm.type == 'textarea' ? null : _vm.type) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "cols": _vm.cols,
      "disabled": _vm.disabled,
      "id": _vm.id,
      "list": _vm.id_datalist,
      "max": _vm.attr(_vm.max),
      "maxlength": _vm.maxlength,
      "min": _vm.attr(_vm.min),
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "required": _vm.required,
      "rows": _vm.rows,
      "step": _vm.step,
      "title": _vm.attr(_vm.title),
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.val, null)
    },
    on: {
      "blur": _vm.emit,
      "focus": _vm.emit,
      "input": _vm.emit,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.type != 'textarea' && _vm.enterSubmit && _vm.submit()
      },
      "change": function($event) {
        _vm.val = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    staticClass: "form-control",
    attrs: {
      "cols": _vm.cols,
      "disabled": _vm.disabled,
      "id": _vm.id,
      "list": _vm.id_datalist,
      "max": _vm.attr(_vm.max),
      "maxlength": _vm.maxlength,
      "min": _vm.attr(_vm.min),
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "required": _vm.required,
      "rows": _vm.rows,
      "step": _vm.step,
      "title": _vm.attr(_vm.title),
      "type": _vm.type == 'textarea' ? null : _vm.type
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "blur": _vm.emit,
      "focus": _vm.emit,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.val = $event.target.value
      }, _vm.emit],
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.type != 'textarea' && _vm.enterSubmit && _vm.submit()
      }
    }
  }), _vm._v(" "), (_vm.clearButton && _vm.val) ? _c('span', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.val = ''
      }
    }
  }, [_vm._v("×")]) : _vm._e(), _vm._v(" "), (_vm.icon && _vm.valid !== null) ? _c('span', {
    class: ['form-control-feedback glyphicon', 'glyphicon-' + (_vm.valid ? 'ok' : 'remove')],
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()], _vm._v(" "), (_vm.id_datalist) ? _c('datalist', {
    attrs: {
      "id": _vm.id_datalist
    }
  }, _vm._l((_vm.options), function(opc) {
    return _c('option', {
      domProps: {
        "value": opc
      }
    })
  }), 0) : _vm._e(), _vm._v(" "), (_vm.showHelp) ? _c('div', {
    staticClass: "text-muted",
    on: {
      "click": _vm.focus
    }
  }, [_vm._v(_vm._s(_vm.help))]) : _vm._e(), _vm._v(" "), (_vm.showError) ? _c('div', {
    class: _vm.errorStyle,
    on: {
      "click": _vm.focus
    }
  }, [_vm._v(_vm._s(_vm.errorText))]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a34481ec","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/XmInput.vue
// module id = 1343
// module chunks = 16